/** @jsxImportSource @emotion/react */
import { useDispatch, useSelector } from "react-redux";
import { Badge, FormGroup, FormText, Input, Label } from "reactstrap";
import { updateTenantState } from "../../../actions/Tenants/actions";
import MetaForm from "../../Forms/MetaForm";
import useConfig from "../../../actions/Tenants/config/configHook";

interface ListTenantConfigProps {
    title: string;
}

const booleanOptions = [{ value: true, text: "True" }, { value: false, text: "False" }];

function ListTenantInformation({ title }: ListTenantConfigProps) {
    const current = useSelector<any, any>((state) => state.tenants.current);
    const { tenant_group } = current;
    const dispatch = useDispatch();
    const config = useConfig();

    const onChange = (e) => {
        dispatch(updateTenantState({ ...current, [e.target.name]: e.target.value }));
    };

    const stringify = (value) => (value === null ? "" : value);

    const features = [
        {
            name: "tenant_name",
            label: "Tenant name",
            description: "Give this tenant a recognizable name",
            type: "text",
        },
        {
            name: "tenant_country",
            label: "Tenant country",
            description: "The primary country of this tenant. Has no side effects.",
            type: "text",
        },
        {
            name: "tenant_id",
            label: "Tenant ID",
            description: <div>Unique identifier for this tenant, go to <a href="https://www.whatismytenantid.com" rel="noopener noreferrer" target="_blank">https://www.whatismytenantid.com</a> <Badge color="danger">Testable: No</Badge></div>,
            type: "text",
            disabled: true,
        },
        {
            type: "element",
            el: (
                <FormGroup className="pb-2">
                    <Label for="tenant_group">Tenant Group</Label>
                    <Input type="text" name="tenant_group" id="tenant_group" value={stringify(tenant_group)} onChange={onChange} />
                    <FormText color="muted">Give multiple tenants the same tenant group to let them view eachothers data  <Badge color="success">Testable: Yes</Badge></FormText>
                </FormGroup>
            )
        },
        {
            name: "powerbi-workspace",
            label: "PowerBi workspace ID",
            description: <div>Fill with PowerBI workspace id created for this tenant <Badge color="success">Testable: Yes</Badge></div>,
            type: "text",
        },
        {
            name: "powerbi_report",
            label: "PowerBI report ID",
            description: <div>Fill with PowerBI report id created for this tenant <Badge color="success">Testable: Yes</Badge></div>,
            type: "text",
        },
        {
            name: "active",
            label: "Active",
            description: "Is this tenant able to login?",
            type: "radio",
            options: booleanOptions
        },
        {
            name: "has_two_fta",
            label: "Has multiple FTA",
            description: "Uses pressure_1 and pressure_2",
            type: "radio",
            options: booleanOptions
        },
    ];

    return (
        <div id={title}>
            <MetaForm
                config={config}
                meta={features}
                object={current}
                setValue={(field, value) => dispatch(updateTenantState({ ...current, [field]: value }))}
            />
        </div>
    );
}

export default ListTenantInformation;
